import { App } from "@capacitor/app";
import { isNativeApp } from "./platform";
import { safeInternalPath } from "./utils";

/**
 * The page inside the app for a link that opened it: an invite or board link
 * on the website, or the same path on the gridaction:// scheme. Anything else is
 * ignored, so a link from another app can only move within GridAction.
 */
export function appPathForLink(link: string): string | null {
  let url: URL;
  try {
    url = new URL(link);
  } catch {
    return null;
  }
  // In gridaction://join/abc the first segment lands in the host position.
  const path = url.protocol === "https:" ? url.pathname : `/${url.host}${url.pathname}`;
  if (/^\/join\/[\w-]+$/.test(path)) return path;
  if (path === "/app" || path.startsWith("/app/")) return safeInternalPath(path + url.search);
  return null;
}

export function listenForAppLinks(open: (path: string) => void) {
  if (!isNativeApp) return;
  void App.addListener("appUrlOpen", ({ url }) => {
    const path = appPathForLink(url);
    if (path) open(path);
  });
}
